/* VCTparts reviews slider (sections/vct-reviews-slider.liquid). Moved out of
   the section so the browser caches it; settings come from the data-*
   attributes on [data-vct-rv]. */
  (function () {
    if (window.__vctRvLoaded) return;          // snippet 2x op de pagina? script maar één keer
    window.__vctRvLoaded = true;

    var T = {
      nl: { reviews: 'reviews', via: 'op Feedback Company', note: 'Selectie van onze reviews', translated: 'Automatisch vertaald', stars: 'van 5 sterren', locale: 'nl-NL',
            independent: 'Onafhankelijk verzameld door', verified: 'Geverifieerde review', source: 'Review via Feedback Company', open: 'Bekijk deze review op Feedback Company' },
      de: { reviews: 'Bewertungen', via: 'bei Feedback Company', note: 'Auswahl unserer Bewertungen', translated: 'Automatisch übersetzt', stars: 'von 5 Sternen', locale: 'de-DE',
            independent: 'Unabhängig gesammelt von', verified: 'Verifizierte Bewertung', source: 'Bewertung über Feedback Company', open: 'Diese Bewertung bei Feedback Company ansehen' },
      fr: { reviews: 'avis', via: 'sur Feedback Company', note: 'Sélection de nos avis', translated: 'Traduit automatiquement', stars: 'sur 5 étoiles', locale: 'fr-BE',
            independent: 'Collectés de manière indépendante par', verified: 'Avis vérifié', source: 'Avis via Feedback Company', open: 'Voir cet avis sur Feedback Company' }
    };

    var roots = document.querySelectorAll('[data-vct-rv]');
    if (!roots.length) return;
    var endpoint = roots[0].getAttribute('data-endpoint');
    if (!endpoint || endpoint.indexOf('JOUW-SUBDOMEIN') > -1) return;

    fetch(endpoint, { credentials: 'omit' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data || !data.reviews || !data.reviews.length) return;
        for (var i = 0; i < roots.length; i++) build(roots[i], data);
      })
      .catch(function () { /* geen data = sectie blijft verborgen */ });

    /* Feedback Company-logo in één kleur (currentColor); ster en vinkje = 'star' en 'check-circle' uit snippets/vct-icon.liquid */
    var FC_LOGO = '<svg viewBox="0 2 100 95" aria-hidden="true" focusable="false"><g fill="currentColor">' +
      '<path d="M57.97,7.98C56.32,7.98 54.98,9.33 54.98,10.98L54.98,44.05C54.98,45.7 56.32,47.04 57.97,47.04L81.98,47.04C82.56,47.04 83.14,47.21 83.63,47.54L94.02,54.43L94.02,10.98C94.02,9.33 92.68,7.98 91.03,7.98L57.97,7.98ZM97.01,63C96.43,63 95.86,62.83 95.36,62.5L81.08,53.03L57.97,53.03C53.03,53.03 49,49 49,44.05L49,10.98C49,6.03 53.03,2 57.97,2L91.03,2C95.97,2 100,6.03 100,10.98L100,60.01C100,61.11 99.39,62.12 98.43,62.65C97.98,62.88 97.5,63 97.01,63Z"/>' +
      '<path d="M26.93,97C26.46,97 25.98,96.88 25.55,96.64C24.59,96.12 24,95.1 24,93.99L24,51.02C24,46.05 27.95,42 32.8,42L37.69,42C39.32,42 40.63,43.35 40.63,45.01C40.63,46.67 39.32,48.02 37.69,48.02L32.8,48.02C31.19,48.02 29.87,49.36 29.87,51.02L29.87,88.39L38.38,82.6C38.86,82.28 39.42,82.1 40,82.1L60.19,82.1C61.81,82.1 63.13,80.75 63.13,79.1L63.13,64.57C63.13,62.9 64.44,61.56 66.07,61.56C67.69,61.56 69,62.9 69,64.57L69,79.1C69,84.07 65.05,88.12 60.19,88.12L40.89,88.12L28.56,96.5C28.07,96.83 27.5,97 26.93,97Z"/>' +
      '<path d="M16.05,60.77C16.68,62.12 16.23,63.73 15,64.55L4.62,71.5C4.13,71.83 3.55,72 2.98,72C2.5,72 2.01,71.88 1.57,71.64C0.6,71.12 0,70.1 0,68.99L0,26.02C0,21.04 4,17 8.93,17L37.85,17C39.41,17 40.83,18.13 40.98,19.7C41.16,21.5 39.77,23.02 38.02,23.02L8.93,23.02C7.29,23.02 5.96,24.36 5.96,26.02L5.96,63.39L11.71,59.54C13.23,58.52 15.28,59.11 16.05,60.77Z"/></g></svg>';
    var ICON_ATTRS = ' viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"';
    var CHECK = '<svg class="vct-icon vct-rv__check"' + ICON_ATTRS + '><circle cx="12" cy="12" r="10"/><path d="m9 12 2 2 4-4"/></svg>';
    var STAR = '<svg class="vct-icon"' + ICON_ATTRS + '><path fill="currentColor" stroke="none" d="M11.53 2.3a.53.53 0 0 1 .94 0l2.31 4.68a2.12 2.12 0 0 0 1.6 1.16l5.16.76a.53.53 0 0 1 .3.9l-3.74 3.64a2.12 2.12 0 0 0-.61 1.88l.88 5.14a.53.53 0 0 1-.77.56l-4.62-2.43a2.12 2.12 0 0 0-1.97 0L6.4 21.01a.53.53 0 0 1-.77-.56l.88-5.14a2.12 2.12 0 0 0-.61-1.88L2.16 9.8a.53.53 0 0 1 .3-.9l5.16-.76a2.12 2.12 0 0 0 1.6-1.16z"/></svg>';

    function el(tag, cls, text) {
      var e = document.createElement(tag);
      if (cls) e.className = cls;
      if (text != null) e.textContent = text;
      return e;
    }

    function build(root, data) {
      var lang = root.getAttribute('data-lang');
      if (!T[lang]) lang = 'nl';
      var t = T[lang];
      if (lang === 'nl' && root.getAttribute('data-host').indexOf('vctparts.be') > -1) t.locale = 'nl-BE';
      var fcUrl = root.getAttribute('data-fc-url');

      /* Kop: echte totaalscore van alle reviews + externe bron */
      var score = root.querySelector('[data-vct-score]');
      if (data.summary && data.summary.score) {
        var hs = score.appendChild(el('span', 'vct-rv__stars'));
        hs.setAttribute('aria-hidden', 'true');
        hs.innerHTML = STAR + STAR + STAR + STAR + STAR;
        score.appendChild(el('strong', null, String(Number(data.summary.score).toFixed(1)) + '/10'));
        var a = el('a', null, Number(data.summary.count).toLocaleString(t.locale) + ' ' + t.reviews + ' ' + t.via);
        a.href = fcUrl; a.target = '_blank'; a.rel = 'noopener';
        score.appendChild(a);
        score.appendChild(el('span', 'vct-rv__muted', '· ' + t.note));
      }
      var badge = el('a', 'vct-rv__badge');
      badge.href = fcUrl; badge.target = '_blank'; badge.rel = 'noopener';
      badge.innerHTML = '<span class="vct-rv__badge-logo">' + FC_LOGO + '</span>';
      var bt = el('span', 'vct-rv__badge-text');
      bt.appendChild(el('small', null, t.independent));
      bt.appendChild(el('strong', null, 'Feedback Company'));
      badge.appendChild(bt);
      root.querySelector('[data-vct-badge]').appendChild(badge);

      /* Kaartjes */
      var track = root.querySelector('[data-vct-track]');
      data.reviews.forEach(function (r) {
        var li = el('li', 'vct-rv__card');
        var rating = el('p', 'vct-rv__rating');
        rating.setAttribute('role', 'img');
        rating.setAttribute('aria-label', String(r.stars).replace('.', ',') + ' ' + t.stars);
        for (var s = 1; s <= 5; s++) {
          var cls = r.stars >= s ? ' is-on' : (r.stars >= s - 0.5 ? ' is-half' : '');
          var sv = rating.appendChild(el('span', 'vct-rv__star' + cls));
          sv.innerHTML = STAR + (cls === ' is-half' ? '<span class="vct-rv__star-half">' + STAR + '</span>' : '');
        }
        li.appendChild(rating);
        var txt = (r.text && r.text[lang]) || r.text.nl;
        var tp = el('p', 'vct-rv__text', txt); tp.title = txt;
        li.appendChild(tp);

        var who = el('p', 'vct-rv__who');
        who.appendChild(el('strong', null, r.name));
        if (r.date) {
          var d = new Date(r.date + 'T12:00:00');
          if (!isNaN(d)) who.appendChild(el('span', null, d.toLocaleDateString(t.locale, { day: 'numeric', month: 'short', year: 'numeric' })));
        }
        li.appendChild(who);

        var src = el('p', 'vct-rv__source');
        var link = el('a', null);
        link.href = fcUrl.replace('/reviews/vctparts/', '/review/vctparts/' + encodeURIComponent(r.id) + '/');
        link.target = '_blank'; link.rel = 'noopener'; link.title = t.open;
        link.innerHTML = '<span class="vct-rv__src-icon">' + (r.verified ? CHECK : FC_LOGO) + '</span>';
        link.appendChild(el('span', null, r.verified ? t.verified : t.source));
        src.appendChild(link);
        if (lang !== 'nl' && r.translated && r.translated[lang]) src.appendChild(el('span', 'vct-rv__muted vct-rv__tr', t.translated));
        li.appendChild(src);
        track.appendChild(li);
      });

      root.hidden = false;
      initSlider(root);
    }

    function initSlider(root) {
      var track = root.querySelector('[data-vct-track]');
      var cards = track ? track.children : [];
      var dotsEl = root.querySelector('[data-vct-dots]');
      var prev = root.querySelector('[data-vct-prev]');
      var next = root.querySelector('[data-vct-next]');
      if (!track || !cards.length) return;
      var cur = 0, timer = null;

      function perView() {
        var w = root.clientWidth;
        if (w <= 560) return 1;
        if (w <= 860) return 2;
        if (w <= 1100) return 3;
        return 4;
      }
      function gap() { return parseFloat(getComputedStyle(track).gap) || 16; }
      function maxIndex() { return Math.max(0, cards.length - perView()); }
      function step() { return cards[0].getBoundingClientRect().width + gap(); }

      function render() {
        track.style.transform = 'translateX(-' + (step() * cur) + 'px)';
        if (prev) prev.disabled = cur === 0;
        if (next) next.disabled = cur >= maxIndex();
        if (dotsEl) {
          var dots = dotsEl.children;
          for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('is-on', i === cur);
        }
      }
      function go(n) { cur = Math.max(0, Math.min(n, maxIndex())); render(); }
      function buildDots() {
        if (!dotsEl) return;
        dotsEl.innerHTML = '';
        var n = maxIndex() + 1;
        if (n > 8) { dotsEl.style.display = 'none'; return; }
        dotsEl.style.display = '';
        for (var i = 0; i < n; i++) { var d = document.createElement('span'); d.className = 'vct-rv__dot'; dotsEl.appendChild(d); }
      }
      function restart() {
        if (timer) clearInterval(timer);
        timer = setInterval(function () { go(cur >= maxIndex() ? 0 : cur + 1); }, 6000);
      }

      if (prev) prev.addEventListener('click', function () { go(cur - 1); restart(); });
      if (next) next.addEventListener('click', function () { go(cur + 1); restart(); });

      var sx = 0, sy = 0;
      track.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
      track.addEventListener('touchend', function (e) {
        var dx = sx - e.changedTouches[0].clientX, dy = sy - e.changedTouches[0].clientY;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { go(dx > 0 ? cur + 1 : cur - 1); restart(); }
      });
      root.addEventListener('mouseenter', function () { if (timer) clearInterval(timer); timer = null; });
      root.addEventListener('mouseleave', restart);

      var rt;
      window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { buildDots(); go(cur); }, 120); });

      buildDots(); go(0); restart();
    }
  })();
